<template>
    <div class="bgColor">
        <header class="public-width">
            <el-row>
                <el-col :span="8">您好 ! 欢迎来到{{ schoolInfo.fullName }}</el-col>
                <el-col :span="2" :offset="14" class="login">
                    <el-dropdown v-if="token">
                        <span class="el-dropdown-link">

                            {{ personInfo.studentName }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="$router.push('/personCenter')">个人中心</el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="$router.push('/collectList')">我的收藏</el-dropdown-item> -->
                            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>

                        </el-dropdown-menu>
                    </el-dropdown>
                    <div v-else @click="$router.push('/login')"><i class="el-icon-user-solid"></i><span>学生登录</span></div>
                </el-col>
            </el-row>
        </header>
    </div>

</template>
<script>
import { mapGetters } from 'vuex';
import { logout } from '@/utils/api'
export default {
    computed: mapGetters(['schoolInfo', 'token', 'personInfo']),
    methods: {
        logout() {
            logout({ id: this.token,organizeId:this.$config.schoolId }).then(res => {
                if (res.code == 200) {
                    this.$message.success('退出登录成功')
                    this.$store.commit('set_token', '')
                    this.$store.commit('set_user_info', {})
                    if (this.$route.path === '/personCenter') {
                        this.$router.push('/')
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss">
.bgColor {
    width: 100%;
    margin: 0 auto;
    background-color: var(--swiper-theme-color);

    header {
        width: 1280px;
        margin: 0 auto;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        margin-bottom: -10px;
        color: #fff;
 .el-row{
    background-color: var(--swiper-theme-color);
 }
        .el-col {
            div {
                color: #fff;
                cursor: pointer;
            }

            &:last-child {
                text-align: right;
                color: #333;
            }

            a {}

            .el-icon-user-solid {
                font-size: 14px;
                margin-right: 4px;
            }
        }
    }
}
</style>